export default 'M0 7a4 4 0 0 1 4-4h16a4 4 0 0 1 4 4zm0 3h24v7a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4zm4 6h6v-2H4z';